/* eslint-disable react/destructuring-assignment */
import React from 'react';

import ChartIconMenu from '@/assets/icons/CycleGraph.svg';
import StatusIconMenu from '@/assets/icons/CycleInfo.svg';
import * as APPDATA from '@/constants/pcConstAppData';
import {GetPathOfPage} from '@/libs/appHelper';

import BottomMenuCommon from '../../menu/bottommenu/BottomMenuCommon';

/**
 * @deprecated redundant with another available constant
 */
const StatusMenu = {
  STATUS: 'STATUS',
  GRAPH: 'GRAPH',
};

export default class StatusPageMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: undefined,
    };
  }

  componentDidMount() {
    const activePageAddress = GetPathOfPage(window.location.href);
    let activeMenu;
    switch (activePageAddress) {
      case APPDATA.STATUS_ADDRESS:
        activeMenu = StatusMenu.STATUS;
        break;
      case APPDATA.VOLUME_SENSOR_CHART_ADDRESS:
        activeMenu = StatusMenu.GRAPH;
        break;
      default:
        activeMenu = StatusMenu.STATUS;
        break;
    }

    this.setState({
      activeMenu,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onClick = (e) => {
    switch (e.currentTarget.id) {
      case StatusMenu.STATUS:
        window.location.href = APPDATA.STATUS_ADDRESS;
        break;
      case StatusMenu.GRAPH:
        window.location.href = APPDATA.VOLUME_SENSOR_CHART_ADDRESS;
        break;
      default:
        window.location.href = APPDATA.STATUS_ADDRESS;
    }
  };

  render() {
    const buttonMenuParam = {
      activeId: this.state.activeMenu,
      buttonProps: [
        {id: StatusMenu.STATUS, label: StatusMenu.STATUS, onClick: this.onClick, icon: ChartIconMenu},
        {id: StatusMenu.GRAPH, label: StatusMenu.GRAPH, onClick: this.onClick, icon: StatusIconMenu},
      ],
    };

    return <BottomMenuCommon buttonParam={buttonMenuParam} />;
  }
}

StatusPageMenu.Menu = StatusMenu;
